'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _keys = require('./keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = (0, _prep2.default)({
    name: 'keyArray',
    all: function all() {
        return function (value) {
            return [].concat(_toConsumableArray((0, _keys2.default)()(value)));
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/keyArray.js
// module id = 194
// module chunks = 35783957827783